import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import logo from "../assets/img/brandimg.png";
import { useAuth } from '../utils/AuthContext';

import {
    dashboardMenu,
    pagesMenu
} from "../data/Menu";

const ProUpgradeBanner = () => (
    <div className="upgrade-banner mx-3 mt-5">
        <div className="card">
            <div className="card-body position-relative">
                <div className="banner-content">
                    <h6 className="text-white mb-2">Unlock premium features and take control of your finances</h6>
                    <Link to="/dashboard/pricing" className="btn btn-get-pro">
                        Upgrade
                    </Link>
                </div>
            </div>
        </div>
        <style>{`
            .upgrade-banner .card {
                border: none;
                background: #1e3a8a;
                border-radius: 10px;
                overflow: hidden;
                position: relative;
                isolation: isolate;
            }
            .upgrade-banner .card::before {
                content: '';
                position: absolute;
                top: -15px;
                right: -15px;
                width: 90px;
                height: 90px;
                background-image: url(${logo});
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
                opacity: 0.7;
                transform: rotate(15deg);
                z-index: 0;
            }
            .card-body {
                padding: 1.25rem;
            }
            .banner-content {
                position: relative;
                z-index: 1;
            }
            .upgrade-banner h6 {
                font-size: 13px;
                line-height: 1.5;
                font-weight: 400;
                margin-right: 20px;
                color: rgba(255, 255, 255, 0.9);
            }
            .btn-get-pro {
                background: #60a5fa;
                color: #1e3a8a;
                border: none;
                padding: 6px 16px;
                border-radius: 6px;
                font-size: 13px;
                font-weight: 500;
                transition: all 0.2s;
                margin-top: 0.5rem;
            }
            .btn-get-pro:hover {
                background: #3b82f6;
                color: #fff;
            }
            [data-skin="dark"] .upgrade-banner .card {
                background: #1e40af;
            }
        `}</style>
    </div>
);

const SidebarContent = () => {
    const { subscription } = useAuth();
    const isPremium = subscription === 'premium';

    return (
        <div className="sidebar">
            <div className="sidebar-header">
                <img src={logo} alt="logo" className="sidebar-logo" style={{ height: "150px"}} />
            </div>
            <PerfectScrollbar className="sidebar-body">
                <SidebarMenu />
                {!isPremium && <ProUpgradeBanner />}
            </PerfectScrollbar>
        </div>
    );
};

export default function Sidebar() {
    return <SidebarContent />;
}

class SidebarMenu extends Component {
    populateMenu = (m) => {
        const menu = m.map((m, key) => {
            let sm;
            if (m.submenu) {
                sm = m.submenu.map((sm, key) => {
                    return (
                        <NavLink to={sm.link} className="nav-sub-link" key={key}>{sm.label}</NavLink>
                    )
                })
            }

            return (
                <li key={key} className="nav-item">
                    {(!sm) ? (
                        <NavLink to={m.link} className="nav-link"><i className={m.icon}></i> <span>{m.label}</span></NavLink>
                    ) : (
                        <div onClick={this.toggleSubMenu} className="nav-link has-sub"><i className={m.icon}></i> <span>{m.label}</span></div>
                    )}
                    {m.submenu && <nav className="nav nav-sub">{sm}</nav>}
                </li>
            )
        });

        return (
            <ul className="nav nav-sidebar">
                {menu}
            </ul>
        );
    }

    // Toggle menu group
    toggleMenu = (e) => {
        e.preventDefault();
        let parent = e.target.closest('.nav-group');
        parent.classList.toggle('show');
    }

    // Toggle submenu while closing siblings' submenu
    toggleSubMenu = (e) => {
        e.preventDefault();
        let parent = e.target.closest('.nav-item');
        let node = parent.parentNode.firstChild;

        while (node) {
            if (node !== parent && node.nodeType === Node.ELEMENT_NODE)
                node.classList.remove('show');
            node = node.nextElementSibling || node.nextSibling;
        }

        parent.classList.toggle('show');
    }

    render() {
        return (
            <React.Fragment>
                <div className="nav-group show">
                    <div className="nav-label" onClick={this.toggleMenu}>Dashboard</div>
                    {this.populateMenu(dashboardMenu)}
                </div>
                <div className="nav-group show">
                    <div className="nav-label" onClick={this.toggleMenu}>Apps</div>
                    {this.populateMenu(pagesMenu)}
                </div>
            </React.Fragment>
        )
    }
}

window.addEventListener("click", function (e) {
    // Close sidebar footer menu when clicked outside of it
    let tar = e.target;
    let sidebar = document.querySelector(".sidebar");
    if (!tar.closest(".sidebar-footer") && sidebar) {
        sidebar.classList.remove("footer-menu-show");
    }

    // Hide sidebar offset when clicked outside of sidebar
    if (!tar.closest(".sidebar") && !tar.closest(".menu-link")) {
        document.querySelector("body").classList.remove("sidebar-show");
    }
});

window.addEventListener("load", function () {
    let skinMode = localStorage.getItem("sidebar-skin");
    let HTMLTag = document.querySelector("html");

    if (skinMode) {
        HTMLTag.setAttribute("data-sidebar", skinMode);
    }
});